import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, catchError, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({ name: 'secure' })
export class SecurePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  //Transform img src to trigger the http interceptor
  transform(url: string | null | undefined): Observable<SafeUrl> {
    const normalizedUrl = String(url ?? '').trim();
    if (!normalizedUrl) {
      return of(this.sanitizer.bypassSecurityTrustUrl(''));
    }

    return this.http.get(normalizedUrl, { responseType: 'blob' }).pipe(
      map((val) => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))),
      catchError(() => of(this.sanitizer.bypassSecurityTrustUrl('')))
    );
  }
}